import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Router, ActivatedRoute} from '@angular/router';
import {Store, select} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {ParticleService} from '@core/services/particle.service';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {
  CopyFilingFromExistingCaseCommand,
  CreateArrangementCommand, CreateArrangementFromExistingCaseCommand,
  CreatePreArrangementCommand,
  CreatePreArrangementFromExistingCaseCommand, ExportCaseCommand
} from '../../commands/dac6-reporter.command';
import {ViewSynchronizerService} from '@shared/components/platform-sidebar/store/view-synchronizer.service';
import {CreateChatConversationCommand} from '../../../task-manager/collaboration/store/collaboration.command';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {ConversationComponentName} from '../../../task-manager/collaboration/store/collaboration.constants';
import {CreateChatConversationAction} from '../../../task-manager/collaboration/store/collaboration.action';
import {CollaborationState} from '../../../task-manager/collaboration/store/collaboration.reducer';
import {FileManagementService} from '@core/services/file-management.service';
import {Configuration} from '@shared/models/configuration';
import {SetActivityFeedAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { CommandService } from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {User_Specefic_Grid_Filter, Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {ParticleCacheService} from '@core/services/particle-cache.service';

@Component({
    standalone: false,
    selector: 'particle-case-content',
  templateUrl: './case-content.component.html',
  styleUrls: ['./case-content.component.scss']
})
export class CaseContentComponent implements OnInit, OnDestroy {

  sourceType: string;
  applyFilterId: string;
  isClose = false;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  endpoint = 'Dac6Api';

  constructor(private router: Router, private store: Store<IDac6ReporterState>,
              private particleService: ParticleService,
              private particleStore: Store<ParticleState>,
              private viewSynchronizerService: ViewSynchronizerService,
              protected commandService: CommandService,
              private collaborationStore: Store<CollaborationState>,
              private activatedRoute: ActivatedRoute,
              private snackBarService: SnackBarService,
              private dialogService: DialogService,
              private queryState: Store<IQueryState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService,
              private particleCacheService: ParticleCacheService) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'DAC6',
        title: 'DAC6 & MDR Reporter',
        type: 'DAC6',
        relativeUrl: 'dac6-reporter/overview'
      }
    ];
    this.sourceType = 'Case';
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    // const activityInfo = {type: 'Tool', 'id': 'dac6-reporting-overview', 'title': 'Overview', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.id}`);
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.id}`);
          break;
        case 'CopyCase':
          this.copyCase(event);
          break;
        case 'Start Conversation':
          this.getChatForThisCase(event);
          break;
        case 'OpenCaseFolder':
          this.navigateToCaseFolder(event);
          break;
        case 'ViewActivity':
          this.trackCaseActiviy(event);
          break;
      }
    }
    console.log(event);
  }

  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({
      type: 'ReferenceCode',
      id: event.item.cells['ReferenceCode'].value,
      title: event.item.cells['CaseId'].value,
      isDefault: false,
      isUserAction: true
    }));
  }

  getChatForThisCase(event) {
    this.viewSynchronizerService.setComponentToInitialState();
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      relativePath = relativePath.replace('/Filings', '');
      console.log('rellativePath', relativePath);
      const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
        .pipe(take(2));
      relativeUrl$.subscribe(state => {
        console.log('RelativeUrl', state);
        if (state) {
          this.router.navigateByUrl(state);
        }
      });
      QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});

    }
  }

  createCase() {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent', {'caseType': 'PreArrangement', disableTypeChange: false},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'PreArrangement':
            if (res.data.input.specifyField) {
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res);
            } else {
              if (res.data.input.selectedCase) {
                this.addPreArrangementFromExistingCaseId(res.data.input.title, res.data.input.selectedCase, false);
              } else {
                this.addPreArrangement(res.data.input.title);
              }
            }
            break;
          case 'Arrangement':
            if (res.data.input.specifyField) {
              this.openSelectFieldDialog(res.data.input.selectedCase, 'arrangementmodel', 'Arrangement', res);
            } else {
              if (res.data.input.selectedCase) {
                this.addArrangementFromExistingCaseId(res.data.input.title, res.data.input.selectedCase, false);
              } else {
                this.addArrangement(res.data.input.title);
              }
            }
            break;
        }
      }

    });
  }

  addArrangement(title: string) {
    this.commandService.executeCommand(new CreateArrangementCommand(title)).pipe().subscribe(state => {
      this.router.navigateByUrl(`dac6-reporter/arrangement/${state.Payload.Id}`);
    });
  }


  addArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, copyCount?: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, false, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/detail/${state.Payload.Id}`);
    });
  }

  trackCopyCaseActivity(displayedCaseId: string, existingCaseId: string, copyCount: number, isArchived: boolean) {
    const command = new PlatformCommand('CopyCaseFromOverViewCommand', 'Dac6Api');
    command.fieldValues['CaseId'] = existingCaseId;
    command.fieldValues['DisplayedCaseId'] = displayedCaseId;
    command.fieldValues['IsArchived'] = isArchived;
    command.fieldValues['CopyCount'] = copyCount.toString();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  addPreArrangement(title: string) {
    this.commandService.executeCommand(new CreatePreArrangementCommand(title)).pipe().subscribe(state => {
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }

  addPreArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, copyCount?: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreatePreArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, false, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }

  copyFilingFromExistingCaseCommand(existingCaseId: string, archiveExisting: boolean, copyCount: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CopyFilingFromExistingCaseCommand(existingCaseId, archiveExisting, false, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`/dac6-reporter/filing/monthly`);
    });
  }

  startDataSurvey() {

  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  close() {
    this.isClose = true;
  }

  private copyCase(event: any) {
    const dialogModel: DialogModel = DialogModel.create(
      'Copy Case',
      'CopyCaseDialogComponent', {
        'caseId': event.item.cells.CaseId.displayText,
        'caseType': event.item.cells.Stage.value
      },
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Pre-Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, res.data.input.copyCount);
            } else {
              this.addPreArrangementFromExistingCaseId(event.item.cells.Title.value, res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.copyCount);
              this.trackCopyCaseActivity(res.data.input.caseId, res.data.input.selectedCase, res.data.input.copyCount, res.data.input.archiveExisting);
            }
            break;
          case 'Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'arrangementmodel', 'Arrangement', res, res.data.input.copyCount);
            } else {
              this.addArrangementFromExistingCaseId(event.item.cells.Title.value, res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.copyCount);
              this.trackCopyCaseActivity(res.data.input.caseId, res.data.input.selectedCase, res.data.input.copyCount, res.data.input.archiveExisting);
            }
            break;
          case 'Filing':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'filingmodel', 'Dac6MonthlyFiling', res, res.data.input.copyCount);
            } else {
              this.copyFilingFromExistingCaseCommand(res.data.input.selectedCase, res.data.input.archiveExisting, res.data.input.copyCount);
              this.trackCopyCaseActivity(res.data.input.caseId, res.data.input.selectedCase, res.data.input.copyCount, res.data.input.archiveExisting);
            }
            break;
        }
      }

    });
  }

  export() {
    this.fuseSplashScreenService.show();
    const filtersObject = this.particleCacheService.getUserPreferenceGridSetting(User_Specefic_Grid_Filter, this.sourceType);
    const filters = Object.values(filtersObject);
    const parametersObject = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
    const command = new ExportCaseCommand(filters, parametersObject);
    this.commandService.executeCommand(command).subscribe(state => {
      if (state) {
        this.fileManagementService.downloadClientFileWithId(state.Payload).pipe().subscribe((payload: any) => {
          this.fileManagementService.openSaveFileWindow(payload, 'Cases-Overview.xlsx');
          this.fuseSplashScreenService.hide();
        }, () => {
          this.fuseSplashScreenService.hide();
        });
      }
      this.fuseSplashScreenService.hide();
    }, () => {
      this.fuseSplashScreenService.hide();
    });
  }

  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {
        sourceKey: 'Dac6-RowFieldData-Config',
        params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}
      },
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'PreArrangement':
            this.addPreArrangementFromExistingCaseId(caseData.data.input.title, caseData.data.input.selectedCase, caseData.data.input.archiveExisting, copyCount, res.data.input.selectedFields, false);
            break;
          case 'Arrangement':
            this.addArrangementFromExistingCaseId(caseData.data.input.title, caseData.data.input.selectedCase, caseData.data.input.archiveExisting, copyCount, res.data.input.selectedFields, false);
            break;
          case 'Dac6MonthlyFiling':
            this.copyFilingFromExistingCaseCommand(caseData.data.input.selectedCase, caseData.data.input.archiveExisting, caseData.data.input.copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }

  onBasketChange(event) {
    this.applyFilterId = null;
    setTimeout(() => {
      this.applyFilterId = Configuration.getBasketMappedSourceType(this.sourceType);
    }, 100);
  }
}
